import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/x8HuRDazCFU4i1EqF7S6PP/Diseno_sin_titulo-35.png', 'https://cdn.magicpatterns.com/uploads/rtKGEA2d9PDejuWQzrGrXk/ChatGPT_Image_5_ene_2026,_01_08_26_a.m..png', 'https://cdn.magicpatterns.com/uploads/dTmH6P3E69PEZJGKhBPRM4/ChatGPT_Image_5_ene_2026,_01_16_19_a.m..png', 'https://cdn.magicpatterns.com/uploads/efMUXQtd8ubQ98EPmdZFT8/ChatGPT_Image_5_ene_2026,_01_23_29_a.m..png'];
export function FeaturesCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  return <div className="relative w-full max-w-4xl mx-auto aspect-video overflow-hidden rounded-xl shadow-2xl" data-id="element-221">
      <AnimatePresence mode="wait" data-id="element-222">
        <motion.img key={currentIndex} src={images[currentIndex]} alt={`Feature ${currentIndex + 1}`} initial={{
        opacity: 0,
        scale: 1.1
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.95
      }} transition={{
        duration: 0.7
      }} className="absolute inset-0 w-full h-full object-cover" data-id="element-223" />
      </AnimatePresence>

      {/* Dots navigation */}
      <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2 z-10" data-id="element-224">
        {images.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-3 h-3 rounded-full transition-all duration-300 ${idx === currentIndex ? 'bg-orange-500 w-8' : 'bg-white/70 hover:bg-white'}`} aria-label={`Ver imagen ${idx + 1}`} data-id="element-225" />)}
      </div>
    </div>;
}